import { actionTypes } from "../../../actions/ui/routeDetail/stopFilters";

const initialState = {
  filters: [],
  manuallySelectedStops: [],
  previousStopIndex: null,
  criteria: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_FILTERS:
      return {
        ...state,
        manuallySelectedStops: action.payload.stopIds,
        filters: action.payload.filters,
        criteria: [],
      };
    case actionTypes.UPDATE_SELECTED_STOPS:
      return {
        ...state,
        manuallySelectedStops: action.payload,
      };
    case actionTypes.SET_PREVIOUS_STOP_INDEX:
      return {
        ...state,
        previousStopIndex: action.data,
      };
    case actionTypes.CLEAR_FILTERS:
      return {
        ...state,
        filters: [],
      };
    case actionTypes.CLEAR_SELECTION:
      return {
        ...state,
        filters: [],
        criteria: [],
        manuallySelectedStops: [],
      };
    case actionTypes.SET_CRITERIA: {
      return {
        ...state,
        filters: [],
        manuallySelectedStops: action.data.selectedStopIds,
        criteria: action.data.criteria,
      };
    }
    default:
      return state;
  }
};
